import { jsx as _jsx } from "react/jsx-runtime";
import { Tabs as AntdTabs } from 'antd';
import { Icon } from '../icons/icon.js';
export function Tabs({ moreIcon, addIcon, removeIcon, ...rest }) {
    return (_jsx(AntdTabs, { ...rest, moreIcon: moreIcon === undefined ? _jsx(Icon, { name: "more", size: 16 }) : moreIcon, addIcon: addIcon === undefined ? _jsx(Icon, { name: "add", size: 16 }) : addIcon, removeIcon: removeIcon === undefined ? _jsx(Icon, { name: "close-square", size: 16 }) : removeIcon }));
}
Tabs.TabPane = AntdTabs.TabPane;
//# sourceMappingURL=tabs.js.map